import { defineNuxtPlugin } from '#app/nuxt'
import { LazyIconArrow, LazyIconClock, LazyIconClose, LazyIconCssArrowWhite, LazyIconCssArrow2, LazyIconCssCheckboxChecked, LazyIconCssInputInvalid, LazyIconCssInputValid, LazyIconCssSelect, LazyIconCssStepChecked, LazyIconCustomer, LazyIconDelivery, LazyIconEmail, LazyIconHeadset, LazyIconHeartEmpty, LazyIconHeartFilled, LazyIconPointer, LazyIconReturn, LazyIconSearch, LazyIconService, LazyIconShoppingcart, LazyIconSocialMediaFacebook, LazyIconSocialMediaFacebook2, LazyIconSocialMediaInstagram, LazyIconSocialMediaPinterest, LazyIconSocialMediaYoutube, LazyIconStarHollow, LazyIconStar, LazyIconAccessoires, LazyIconAddressBook, LazyIconAirlinesBrusselsAirlines, LazyIconAirlinesCondor, LazyIconAirlinesCorendon, LazyIconAirlinesEasyjet, LazyIconAirlinesEurowings, LazyIconAirlinesKlm, LazyIconAirlinesLufthansa, LazyIconAirlinesRyanair, LazyIconAirlinesTransavia, LazyIconAirlinesTuiFly, LazyIconAirlinesUnitedAirlines, LazyIconAirlinesVueling, LazyIconArrowarrow, LazyIconBars, LazyIconCheck, LazyIconConfetti, LazyIconCopy, LazyIconCssEnlarge, LazyIconDeliveryMethodsDhl, LazyIconDeliveryMethodsHermes, LazyIconFeather, LazyIconFilter, LazyIconGift, LazyIconGrid, LazyIconInfo, LazyIconKoffers, LazyIconLabelsThuiswinkelWaarborg, LazyIconLabelsTrustedShops, LazyIconLaptoptassen, LazyIconLeaf, LazyIconLightbulb, LazyIconLocation, LazyIconMenu, LazyIconMin, LazyIconNavAccessoires, LazyIconNavKoffers, LazyIconNavLaptoptassen, LazyIconNavPortemonnees, LazyIconNavReistassen, LazyIconNavRugzakken, LazyIconNavSchooltassen, LazyIconNavTassen, LazyIconNavTrolleys, LazyIconNewsletter, LazyIconOrders, LazyIconPackage, LazyIconPassport, LazyIconPay, LazyIconPaymentMethodsAfterpayInternational, LazyIconPaymentMethodsAfterpayRiverty, LazyIconPaymentMethodsAfterpay, LazyIconPaymentMethodsAmericanExpress, LazyIconPaymentMethodsApplePay, LazyIconPaymentMethodsBancontact, LazyIconPaymentMethodsBillink, LazyIconPaymentMethodsDeCadeaukaart, LazyIconPaymentMethodsEps, LazyIconPaymentMethodsFlyingBlue, LazyIconPaymentMethodsGooglePay, LazyIconPaymentMethodsIdealWero, LazyIconPaymentMethodsIdeal, LazyIconPaymentMethodsIn3, LazyIconPaymentMethodsKlarna, LazyIconPaymentMethodsMastercard, LazyIconPaymentMethodsPayByBank, LazyIconPaymentMethodsPayconiq, LazyIconPaymentMethodsPaypalIcon, LazyIconPaymentMethodsTravelbagsCadeaukaart, LazyIconPaymentMethodsVisa, LazyIconPaymentMethodsVvvGiftcard, LazyIconPaymentMethodsWero, LazyIconPaymentcard, LazyIconPercent, LazyIconPlus, LazyIconPortemonnees, LazyIconReistassen, LazyIconRugzakken, LazyIconSchooltassen, LazyIconSecure, LazyIconSignOut, LazyIconSocialMediaTiktok, LazyIconSocialMediaWhatsapp, LazyIconSort, LazyIconSparkle, LazyIconStampLarge, LazyIconStampMedium, LazyIconStampSmall, LazyIconStamp, LazyIconStore, LazyIconStores, LazyIconTassen, LazyIconTrash, LazyIconTravelbags, LazyIconTrolleys, LazyIconTrophy, LazyIconWarning, LazyStrapiBlocksTextLinkInlineNode, LazyStrapiBlocksTextCodeNode, LazyStrapiBlocksTextImageNode, LazyStrapiBlocksTextParagraphNode, LazyStrapiBlocksTextQuoteNode, LazyStrapiBlocksTextHeading1Node, LazyStrapiBlocksTextHeading2Node, LazyStrapiBlocksTextHeading3Node, LazyStrapiBlocksTextHeading4Node, LazyStrapiBlocksTextHeading5Node, LazyStrapiBlocksTextHeading6Node, LazyStrapiBlocksTextBoldInlineNode, LazyStrapiBlocksTextCodeInlineNode, LazyStrapiBlocksTextItalicInlineNode, LazyStrapiBlocksTextListItemInlineNode, LazyStrapiBlocksTextStrikethroughInlineNode, LazyStrapiBlocksTextUnderlineInlineNode, LazyStrapiBlocksTextOrderedListNode, LazyStrapiBlocksTextUnorderedListNode, LazyIconDeprecatedGooglePlus, LazyIconDeprecatedKlarna1, LazyIconDeprecatedKlarnaKonto, LazyIconDeprecatedTnt, LazyIconDeprecatedTrustedShopsV1, LazyIconDeprecatedTwitter, LazyIconDeprecatedVvvGiftcardV1, LazyIconBankenAbnAmro, LazyIconBankenAsn, LazyIconBankenBelfius, LazyIconBankenFortis, LazyIconBankenIng, LazyIconBankenKbc, LazyIconBankenKnab, LazyIconBankenRabobank, LazyIconBankenSns, LazyIconBankenTriodos, LazyIconBankenVanlanschot, LazyIconCalendar, LazyIconChat, LazyIconCssNoImage, LazyIconDeliveryMethodsAnpost, LazyIconDeliveryMethodsAtpost, LazyIconDeliveryMethodsB2ce, LazyIconDeliveryMethodsBpost, LazyIconDeliveryMethodsColissimo, LazyIconDeliveryMethodsDeutschePost, LazyIconDeliveryMethodsDpd, LazyIconDeliveryMethodsFedexExpress, LazyIconDeliveryMethodsFietskoeriers, LazyIconDeliveryMethodsGls, LazyIconDeliveryMethodsGlsdk, LazyIconDeliveryMethodsKiala, LazyIconDeliveryMethodsPostNl, LazyIconDeliveryMethodsSkynet, LazyIconDeliveryMethodsTaxydromikisa, LazyIconDeliveryMethodsTourline, LazyIconDeliveryMethodsUps, LazyIconEnlarge, LazyIconEyeClosed, LazyIconEyeOpen, LazyIconFlagsAu, LazyIconFlagsBe, LazyIconFlagsDe, LazyIconFlagsEs, LazyIconFlagsFr, LazyIconFlagsGb, LazyIconFlagsGlobal, LazyIconFlagsIt, LazyIconFlagsLu, LazyIconFlagsNl, LazyIconLabelsBecommerce, LazyIconLabelsCwb, LazyIconLabelsDrugProvider, LazyIconLabelsEcommerceEuropeTrustmark, LazyIconLabelsEuOrganic, LazyIconLabelsHaendlerbundMitglied, LazyIconLabelsKiyoh, LazyIconLabelsThuiswinkelWaarborgLabelBottom, LazyIconLabelsThuiswinkelWaarborgLabelRight, LazyIconLabelsTrustpilot, LazyIconLabelsWebshopKeurmerkLiggend, LazyIconLabelsWebshopKeurmerkStaand, LazyIconList, LazyIconLoader, LazyIconLock, LazyIconNoLocation, LazyIconPaymentMethodsAcceptgiro, LazyIconPaymentMethodsBancontact1, LazyIconPaymentMethodsBancontactMistercash, LazyIconPaymentMethodsBankoverschrijving, LazyIconPaymentMethodsCarteBancaire, LazyIconPaymentMethodsCarteBleue, LazyIconPaymentMethodsCirrus, LazyIconPaymentMethodsClickAndBuy, LazyIconPaymentMethodsCreditcard, LazyIconPaymentMethodsDankort, LazyIconPaymentMethodsDiscover, LazyIconPaymentMethodsFashionCheque, LazyIconPaymentMethodsGiropay, LazyIconPaymentMethodsIban, LazyIconPaymentMethodsIngHomepay, LazyIconPaymentMethodsKlarnaSmall, LazyIconPaymentMethodsMaestro, LazyIconPaymentMethodsMastercard1, LazyIconPaymentMethodsOverboeking, LazyIconPaymentMethodsPayPerMailEur, LazyIconPaymentMethodsPaypal, LazyIconPaymentMethodsPaypalNoIcon, LazyIconPaymentMethodsPin, LazyIconPaymentMethodsRiverty, LazyIconPaymentMethodsSign2pay, LazyIconPaymentMethodsSofortBanking, LazyIconPaymentMethodsSofortUberweisung, LazyIconPaymentMethodsSofort, LazyIconPaymentMethodsVPay, LazyIconPaymentMethodsWebshopGiftcard, LazyIconPencil, LazyIconPhone, LazyIconPrinter, LazyIconPrismicEdit, LazyIconRefresh, LazyIconSocialMediaEmail, LazyIconSocialMediaLinkedin, LazyIconSocialMediaVimeo, LazyIconSocialMediaX, LazyIconSpike, LazyIconStars, LazyIconThumb, LazyIconWhatsapp, LazyIconZoom, LazyStrapiBlocksText } from '#components'
const lazyGlobalComponents = [
  ["IconArrow", LazyIconArrow],
["IconClock", LazyIconClock],
["IconClose", LazyIconClose],
["IconCssArrowWhite", LazyIconCssArrowWhite],
["IconCssArrow2", LazyIconCssArrow2],
["IconCssCheckboxChecked", LazyIconCssCheckboxChecked],
["IconCssInputInvalid", LazyIconCssInputInvalid],
["IconCssInputValid", LazyIconCssInputValid],
["IconCssSelect", LazyIconCssSelect],
["IconCssStepChecked", LazyIconCssStepChecked],
["IconCustomer", LazyIconCustomer],
["IconDelivery", LazyIconDelivery],
["IconEmail", LazyIconEmail],
["IconHeadset", LazyIconHeadset],
["IconHeartEmpty", LazyIconHeartEmpty],
["IconHeartFilled", LazyIconHeartFilled],
["IconPointer", LazyIconPointer],
["IconReturn", LazyIconReturn],
["IconSearch", LazyIconSearch],
["IconService", LazyIconService],
["IconShoppingcart", LazyIconShoppingcart],
["IconSocialMediaFacebook", LazyIconSocialMediaFacebook],
["IconSocialMediaFacebook2", LazyIconSocialMediaFacebook2],
["IconSocialMediaInstagram", LazyIconSocialMediaInstagram],
["IconSocialMediaPinterest", LazyIconSocialMediaPinterest],
["IconSocialMediaYoutube", LazyIconSocialMediaYoutube],
["IconStarHollow", LazyIconStarHollow],
["IconStar", LazyIconStar],
["IconAccessoires", LazyIconAccessoires],
["IconAddressBook", LazyIconAddressBook],
["IconAirlinesBrusselsAirlines", LazyIconAirlinesBrusselsAirlines],
["IconAirlinesCondor", LazyIconAirlinesCondor],
["IconAirlinesCorendon", LazyIconAirlinesCorendon],
["IconAirlinesEasyjet", LazyIconAirlinesEasyjet],
["IconAirlinesEurowings", LazyIconAirlinesEurowings],
["IconAirlinesKlm", LazyIconAirlinesKlm],
["IconAirlinesLufthansa", LazyIconAirlinesLufthansa],
["IconAirlinesRyanair", LazyIconAirlinesRyanair],
["IconAirlinesTransavia", LazyIconAirlinesTransavia],
["IconAirlinesTuiFly", LazyIconAirlinesTuiFly],
["IconAirlinesUnitedAirlines", LazyIconAirlinesUnitedAirlines],
["IconAirlinesVueling", LazyIconAirlinesVueling],
["IconArrowarrow", LazyIconArrowarrow],
["IconBars", LazyIconBars],
["IconCheck", LazyIconCheck],
["IconConfetti", LazyIconConfetti],
["IconCopy", LazyIconCopy],
["IconCssEnlarge", LazyIconCssEnlarge],
["IconDeliveryMethodsDhl", LazyIconDeliveryMethodsDhl],
["IconDeliveryMethodsHermes", LazyIconDeliveryMethodsHermes],
["IconFeather", LazyIconFeather],
["IconFilter", LazyIconFilter],
["IconGift", LazyIconGift],
["IconGrid", LazyIconGrid],
["IconInfo", LazyIconInfo],
["IconKoffers", LazyIconKoffers],
["IconLabelsThuiswinkelWaarborg", LazyIconLabelsThuiswinkelWaarborg],
["IconLabelsTrustedShops", LazyIconLabelsTrustedShops],
["IconLaptoptassen", LazyIconLaptoptassen],
["IconLeaf", LazyIconLeaf],
["IconLightbulb", LazyIconLightbulb],
["IconLocation", LazyIconLocation],
["IconMenu", LazyIconMenu],
["IconMin", LazyIconMin],
["IconNavAccessoires", LazyIconNavAccessoires],
["IconNavKoffers", LazyIconNavKoffers],
["IconNavLaptoptassen", LazyIconNavLaptoptassen],
["IconNavPortemonnees", LazyIconNavPortemonnees],
["IconNavReistassen", LazyIconNavReistassen],
["IconNavRugzakken", LazyIconNavRugzakken],
["IconNavSchooltassen", LazyIconNavSchooltassen],
["IconNavTassen", LazyIconNavTassen],
["IconNavTrolleys", LazyIconNavTrolleys],
["IconNewsletter", LazyIconNewsletter],
["IconOrders", LazyIconOrders],
["IconPackage", LazyIconPackage],
["IconPassport", LazyIconPassport],
["IconPay", LazyIconPay],
["IconPaymentMethodsAfterpayInternational", LazyIconPaymentMethodsAfterpayInternational],
["IconPaymentMethodsAfterpayRiverty", LazyIconPaymentMethodsAfterpayRiverty],
["IconPaymentMethodsAfterpay", LazyIconPaymentMethodsAfterpay],
["IconPaymentMethodsAmericanExpress", LazyIconPaymentMethodsAmericanExpress],
["IconPaymentMethodsApplePay", LazyIconPaymentMethodsApplePay],
["IconPaymentMethodsBancontact", LazyIconPaymentMethodsBancontact],
["IconPaymentMethodsBillink", LazyIconPaymentMethodsBillink],
["IconPaymentMethodsDeCadeaukaart", LazyIconPaymentMethodsDeCadeaukaart],
["IconPaymentMethodsEps", LazyIconPaymentMethodsEps],
["IconPaymentMethodsFlyingBlue", LazyIconPaymentMethodsFlyingBlue],
["IconPaymentMethodsGooglePay", LazyIconPaymentMethodsGooglePay],
["IconPaymentMethodsIdealWero", LazyIconPaymentMethodsIdealWero],
["IconPaymentMethodsIdeal", LazyIconPaymentMethodsIdeal],
["IconPaymentMethodsIn3", LazyIconPaymentMethodsIn3],
["IconPaymentMethodsKlarna", LazyIconPaymentMethodsKlarna],
["IconPaymentMethodsMastercard", LazyIconPaymentMethodsMastercard],
["IconPaymentMethodsPayByBank", LazyIconPaymentMethodsPayByBank],
["IconPaymentMethodsPayconiq", LazyIconPaymentMethodsPayconiq],
["IconPaymentMethodsPaypalIcon", LazyIconPaymentMethodsPaypalIcon],
["IconPaymentMethodsTravelbagsCadeaukaart", LazyIconPaymentMethodsTravelbagsCadeaukaart],
["IconPaymentMethodsVisa", LazyIconPaymentMethodsVisa],
["IconPaymentMethodsVvvGiftcard", LazyIconPaymentMethodsVvvGiftcard],
["IconPaymentMethodsWero", LazyIconPaymentMethodsWero],
["IconPaymentcard", LazyIconPaymentcard],
["IconPercent", LazyIconPercent],
["IconPlus", LazyIconPlus],
["IconPortemonnees", LazyIconPortemonnees],
["IconReistassen", LazyIconReistassen],
["IconRugzakken", LazyIconRugzakken],
["IconSchooltassen", LazyIconSchooltassen],
["IconSecure", LazyIconSecure],
["IconSignOut", LazyIconSignOut],
["IconSocialMediaTiktok", LazyIconSocialMediaTiktok],
["IconSocialMediaWhatsapp", LazyIconSocialMediaWhatsapp],
["IconSort", LazyIconSort],
["IconSparkle", LazyIconSparkle],
["IconStampLarge", LazyIconStampLarge],
["IconStampMedium", LazyIconStampMedium],
["IconStampSmall", LazyIconStampSmall],
["IconStamp", LazyIconStamp],
["IconStore", LazyIconStore],
["IconStores", LazyIconStores],
["IconTassen", LazyIconTassen],
["IconTrash", LazyIconTrash],
["IconTravelbags", LazyIconTravelbags],
["IconTrolleys", LazyIconTrolleys],
["IconTrophy", LazyIconTrophy],
["IconWarning", LazyIconWarning],
["StrapiBlocksTextLinkInlineNode", LazyStrapiBlocksTextLinkInlineNode],
["StrapiBlocksTextCodeNode", LazyStrapiBlocksTextCodeNode],
["StrapiBlocksTextImageNode", LazyStrapiBlocksTextImageNode],
["StrapiBlocksTextParagraphNode", LazyStrapiBlocksTextParagraphNode],
["StrapiBlocksTextQuoteNode", LazyStrapiBlocksTextQuoteNode],
["StrapiBlocksTextHeading1Node", LazyStrapiBlocksTextHeading1Node],
["StrapiBlocksTextHeading2Node", LazyStrapiBlocksTextHeading2Node],
["StrapiBlocksTextHeading3Node", LazyStrapiBlocksTextHeading3Node],
["StrapiBlocksTextHeading4Node", LazyStrapiBlocksTextHeading4Node],
["StrapiBlocksTextHeading5Node", LazyStrapiBlocksTextHeading5Node],
["StrapiBlocksTextHeading6Node", LazyStrapiBlocksTextHeading6Node],
["StrapiBlocksTextBoldInlineNode", LazyStrapiBlocksTextBoldInlineNode],
["StrapiBlocksTextCodeInlineNode", LazyStrapiBlocksTextCodeInlineNode],
["StrapiBlocksTextItalicInlineNode", LazyStrapiBlocksTextItalicInlineNode],
["StrapiBlocksTextListItemInlineNode", LazyStrapiBlocksTextListItemInlineNode],
["StrapiBlocksTextStrikethroughInlineNode", LazyStrapiBlocksTextStrikethroughInlineNode],
["StrapiBlocksTextUnderlineInlineNode", LazyStrapiBlocksTextUnderlineInlineNode],
["StrapiBlocksTextOrderedListNode", LazyStrapiBlocksTextOrderedListNode],
["StrapiBlocksTextUnorderedListNode", LazyStrapiBlocksTextUnorderedListNode],
["IconDeprecatedGooglePlus", LazyIconDeprecatedGooglePlus],
["IconDeprecatedKlarna1", LazyIconDeprecatedKlarna1],
["IconDeprecatedKlarnaKonto", LazyIconDeprecatedKlarnaKonto],
["IconDeprecatedTnt", LazyIconDeprecatedTnt],
["IconDeprecatedTrustedShopsV1", LazyIconDeprecatedTrustedShopsV1],
["IconDeprecatedTwitter", LazyIconDeprecatedTwitter],
["IconDeprecatedVvvGiftcardV1", LazyIconDeprecatedVvvGiftcardV1],
["IconBankenAbnAmro", LazyIconBankenAbnAmro],
["IconBankenAsn", LazyIconBankenAsn],
["IconBankenBelfius", LazyIconBankenBelfius],
["IconBankenFortis", LazyIconBankenFortis],
["IconBankenIng", LazyIconBankenIng],
["IconBankenKbc", LazyIconBankenKbc],
["IconBankenKnab", LazyIconBankenKnab],
["IconBankenRabobank", LazyIconBankenRabobank],
["IconBankenSns", LazyIconBankenSns],
["IconBankenTriodos", LazyIconBankenTriodos],
["IconBankenVanlanschot", LazyIconBankenVanlanschot],
["IconCalendar", LazyIconCalendar],
["IconChat", LazyIconChat],
["IconCssNoImage", LazyIconCssNoImage],
["IconDeliveryMethodsAnpost", LazyIconDeliveryMethodsAnpost],
["IconDeliveryMethodsAtpost", LazyIconDeliveryMethodsAtpost],
["IconDeliveryMethodsB2ce", LazyIconDeliveryMethodsB2ce],
["IconDeliveryMethodsBpost", LazyIconDeliveryMethodsBpost],
["IconDeliveryMethodsColissimo", LazyIconDeliveryMethodsColissimo],
["IconDeliveryMethodsDeutschePost", LazyIconDeliveryMethodsDeutschePost],
["IconDeliveryMethodsDpd", LazyIconDeliveryMethodsDpd],
["IconDeliveryMethodsFedexExpress", LazyIconDeliveryMethodsFedexExpress],
["IconDeliveryMethodsFietskoeriers", LazyIconDeliveryMethodsFietskoeriers],
["IconDeliveryMethodsGls", LazyIconDeliveryMethodsGls],
["IconDeliveryMethodsGlsdk", LazyIconDeliveryMethodsGlsdk],
["IconDeliveryMethodsKiala", LazyIconDeliveryMethodsKiala],
["IconDeliveryMethodsPostNl", LazyIconDeliveryMethodsPostNl],
["IconDeliveryMethodsSkynet", LazyIconDeliveryMethodsSkynet],
["IconDeliveryMethodsTaxydromikisa", LazyIconDeliveryMethodsTaxydromikisa],
["IconDeliveryMethodsTourline", LazyIconDeliveryMethodsTourline],
["IconDeliveryMethodsUps", LazyIconDeliveryMethodsUps],
["IconEnlarge", LazyIconEnlarge],
["IconEyeClosed", LazyIconEyeClosed],
["IconEyeOpen", LazyIconEyeOpen],
["IconFlagsAu", LazyIconFlagsAu],
["IconFlagsBe", LazyIconFlagsBe],
["IconFlagsDe", LazyIconFlagsDe],
["IconFlagsEs", LazyIconFlagsEs],
["IconFlagsFr", LazyIconFlagsFr],
["IconFlagsGb", LazyIconFlagsGb],
["IconFlagsGlobal", LazyIconFlagsGlobal],
["IconFlagsIt", LazyIconFlagsIt],
["IconFlagsLu", LazyIconFlagsLu],
["IconFlagsNl", LazyIconFlagsNl],
["IconLabelsBecommerce", LazyIconLabelsBecommerce],
["IconLabelsCwb", LazyIconLabelsCwb],
["IconLabelsDrugProvider", LazyIconLabelsDrugProvider],
["IconLabelsEcommerceEuropeTrustmark", LazyIconLabelsEcommerceEuropeTrustmark],
["IconLabelsEuOrganic", LazyIconLabelsEuOrganic],
["IconLabelsHaendlerbundMitglied", LazyIconLabelsHaendlerbundMitglied],
["IconLabelsKiyoh", LazyIconLabelsKiyoh],
["IconLabelsThuiswinkelWaarborgLabelBottom", LazyIconLabelsThuiswinkelWaarborgLabelBottom],
["IconLabelsThuiswinkelWaarborgLabelRight", LazyIconLabelsThuiswinkelWaarborgLabelRight],
["IconLabelsTrustpilot", LazyIconLabelsTrustpilot],
["IconLabelsWebshopKeurmerkLiggend", LazyIconLabelsWebshopKeurmerkLiggend],
["IconLabelsWebshopKeurmerkStaand", LazyIconLabelsWebshopKeurmerkStaand],
["IconList", LazyIconList],
["IconLoader", LazyIconLoader],
["IconLock", LazyIconLock],
["IconNoLocation", LazyIconNoLocation],
["IconPaymentMethodsAcceptgiro", LazyIconPaymentMethodsAcceptgiro],
["IconPaymentMethodsBancontact1", LazyIconPaymentMethodsBancontact1],
["IconPaymentMethodsBancontactMistercash", LazyIconPaymentMethodsBancontactMistercash],
["IconPaymentMethodsBankoverschrijving", LazyIconPaymentMethodsBankoverschrijving],
["IconPaymentMethodsCarteBancaire", LazyIconPaymentMethodsCarteBancaire],
["IconPaymentMethodsCarteBleue", LazyIconPaymentMethodsCarteBleue],
["IconPaymentMethodsCirrus", LazyIconPaymentMethodsCirrus],
["IconPaymentMethodsClickAndBuy", LazyIconPaymentMethodsClickAndBuy],
["IconPaymentMethodsCreditcard", LazyIconPaymentMethodsCreditcard],
["IconPaymentMethodsDankort", LazyIconPaymentMethodsDankort],
["IconPaymentMethodsDiscover", LazyIconPaymentMethodsDiscover],
["IconPaymentMethodsFashionCheque", LazyIconPaymentMethodsFashionCheque],
["IconPaymentMethodsGiropay", LazyIconPaymentMethodsGiropay],
["IconPaymentMethodsIban", LazyIconPaymentMethodsIban],
["IconPaymentMethodsIngHomepay", LazyIconPaymentMethodsIngHomepay],
["IconPaymentMethodsKlarnaSmall", LazyIconPaymentMethodsKlarnaSmall],
["IconPaymentMethodsMaestro", LazyIconPaymentMethodsMaestro],
["IconPaymentMethodsMastercard1", LazyIconPaymentMethodsMastercard1],
["IconPaymentMethodsOverboeking", LazyIconPaymentMethodsOverboeking],
["IconPaymentMethodsPayPerMailEur", LazyIconPaymentMethodsPayPerMailEur],
["IconPaymentMethodsPaypal", LazyIconPaymentMethodsPaypal],
["IconPaymentMethodsPaypalNoIcon", LazyIconPaymentMethodsPaypalNoIcon],
["IconPaymentMethodsPin", LazyIconPaymentMethodsPin],
["IconPaymentMethodsRiverty", LazyIconPaymentMethodsRiverty],
["IconPaymentMethodsSign2pay", LazyIconPaymentMethodsSign2pay],
["IconPaymentMethodsSofortBanking", LazyIconPaymentMethodsSofortBanking],
["IconPaymentMethodsSofortUberweisung", LazyIconPaymentMethodsSofortUberweisung],
["IconPaymentMethodsSofort", LazyIconPaymentMethodsSofort],
["IconPaymentMethodsVPay", LazyIconPaymentMethodsVPay],
["IconPaymentMethodsWebshopGiftcard", LazyIconPaymentMethodsWebshopGiftcard],
["IconPencil", LazyIconPencil],
["IconPhone", LazyIconPhone],
["IconPrinter", LazyIconPrinter],
["IconPrismicEdit", LazyIconPrismicEdit],
["IconRefresh", LazyIconRefresh],
["IconSocialMediaEmail", LazyIconSocialMediaEmail],
["IconSocialMediaLinkedin", LazyIconSocialMediaLinkedin],
["IconSocialMediaVimeo", LazyIconSocialMediaVimeo],
["IconSocialMediaX", LazyIconSocialMediaX],
["IconSpike", LazyIconSpike],
["IconStars", LazyIconStars],
["IconThumb", LazyIconThumb],
["IconWhatsapp", LazyIconWhatsapp],
["IconZoom", LazyIconZoom],
["StrapiBlocksText", LazyStrapiBlocksText],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
